var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoingecko(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "X23Swb.tif",
    transform: "translate(9.818 9.817)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13719",
    "data-name": "Group 13719",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6139",
    "data-name": "Path 6139",
    d: "M1209.465,1179.494a26.306,26.306,0,0,1,8.517-.4,39.9,39.9,0,0,1,5.243,1.367,21.093,21.093,0,0,1,12.645,13.462c2.729,8.55.965,16.365-5.422,22.741-6.13,6.121-13.627,7.967-22,5.658a22.654,22.654,0,0,1-15.4-16.4,22.151,22.151,0,0,1,16.412-26.426Zm-11.486,33.274a49.526,49.526,0,0,0,1.458-5.283c.47-2.9.627-5.841,1.083-8.739a11.791,11.791,0,0,1,1.295-4.1c1.927-3.272,8.059-5.731,11.772-4.837a5.512,5.512,0,0,0,1.866-.082c2.01-.241,3.782-.188,4.992,1.618a3.035,3.035,0,0,0,1.3,1.109c2.126.833,4.346,1.442,6.428,2.368,3.478,1.547,4.074,4.655,1.51,7.478-1.3,1.436-2.728,2.763-4.086,4.152-3.091,3.163-5.891,6.534-7,10.945a24.989,24.989,0,0,0-.365,3.813,20.345,20.345,0,0,0,16.886-16.5c1.8-10.233-3.648-19.45-13.541-23.223-8.442-3.219-19.175.43-24.1,8.061C1192.217,1197.714,1193.666,1207.389,1197.979,1212.769Zm13.921-20.824a3.993,3.993,0,1,0-.078,7.985,4.016,4.016,0,0,0,4.105-3.98A3.909,3.909,0,0,0,1211.9,1191.945Z",
    transform: "translate(-1192.454 -1178.918)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6140",
    "data-name": "Path 6140",
    d: "M1267.523,1246.572a2.694,2.694,0,1,0-.106-5.386,2.693,2.693,0,1,0,.106,5.386Z",
    transform: "translate(-1248.125 -1226.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6141",
    "data-name": "Path 6141",
    d: "M1267.523,1246.572a2.693,2.693,0,1,1-.106-5.386,2.694,2.694,0,1,1,.106,5.386Z",
    transform: "translate(-1248.125 -1226.854)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17858",
    "data-name": "Rectangle 17858",
    width: 64,
    height: 64,
    transform: "translate(-9.818 -9.817)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoingecko);
export default __webpack_public_path__ + "static/media/Coingecko.49fa14e2542caee85605c72ea2d7f8b8.svg";
export { ForwardRef as ReactComponent };